import { isMockServices } from 'src/utils';
import mock from 'src/services/utils/mock';
import { getCompatibleAuthTokenHttp } from '../utils/enhancedAuthTokenHttp';
import { MutationFunction } from '@tanstack/react-query';

export interface BulkImportSummary {
  totalRows: number;
  successCount: number;
  failureCount: number;
  dryRun: boolean;
}

export interface BulkImportError {
  rowNumber?: number;
  message: string;
}

export interface BulkImportResponse {
  success: boolean;
  summary: BulkImportSummary;
  errors: BulkImportError[];
}

const bulkImportUsers: MutationFunction<BulkImportResponse, File> = async (
  file,
) => {
  if (isMockServices()) return await mock(_mockData);
  try {
    const formData = new FormData();
    formData.append('file', file);

    const authTokenHttp = await getCompatibleAuthTokenHttp();
    const response = await authTokenHttp<BulkImportResponse>(
      '/shared/users/bulk-import',
      {
        method: 'POST',
        body: formData,
      },
    );
    if (response.data) return response.data;
    throw new Error('Failed to import users');
  } catch (error: unknown) {
    console.error('Failed to bulk import users:', error);
    throw error;
  }
};

export default bulkImportUsers;

const _mockData: BulkImportResponse = {
  success: true,
  summary: {
    totalRows: 10,
    successCount: 10,
    failureCount: 0,
    dryRun: false,
  },
  errors: [],
};
